import * as types from './dailyReportActionType';

export const fetchDailyPowerBIReportRequest = () => ({
    type: types.FETCH_DAILY_POWER_BI_REPORT_REQUEST
});
export const fetchDailyPowerBIReportSuccess = (data) => ({
    type: types.FETCH_DAILY_POWER_BI_REPORT_SUCCESS,
    payload: data
});
export const fetchDailyPowerBIReportFailure = (error) => ({
    type: types.FETCH_DAILY_POWER_BI_REPORT_FAILURE,
    payload: error
});

export const fetchDailyReportLastRefreshedRequest = () => ({
    type: types.FETCH_DAILY_REPORT_LAST_REFRESHED_REQUEST
});
export const fetchDailyReportLastRefreshedSuccess = (dateTime, nextRefreshDateTime = null) => ({
    type: types.FETCH_DAILY_REPORT_LAST_REFRESHED_SUCCESS,
    payload: { lastRefreshedDateTime: dateTime, nextRefreshDateTime }
});
export const fetchDailyReportLastRefreshedFailure = (error) => ({
    type: types.FETCH_DAILY_REPORT_LAST_REFRESHED_FAILURE,
    payload: error
});
